import { useEffect } from 'react';
import { useAxios } from 'src/hooks/use-axios';
import { useMonolithCurrentUser } from 'src/hooks/use-monolith-user';

type PossibleSettings =
  | 'FCFS'
  | 'CREDIT_LIMIT_FCFS'
  | 'CREDIT_LIMIT_SECONDARY'
  | 'SURRENDER'
  | 'UPGRADE'
  | 'CONVERSION'
  | 'REVERSE_AUCTION';

export type Settings = { [key in PossibleSettings]?: true };

export function useSettings() {
  const auth = useMonolithCurrentUser();

  const settings = useAxios(
    (axios, signal) =>
      axios
        .request<PossibleSettings[]>({
          signal,
          url: `${PRISMA_CONFIG.oldBackendUrl}/tso/${auth.referenceId}/enabled-settings`,
        })
        .then((response) =>
          response.data.reduce<Settings>((acc, value) => {
            acc[value] = true;
            return acc;
          }, {})
        ),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    settings.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return settings;
}

export type SettingsRequest = ReturnType<typeof useSettings>;
